const frontendURL = '/cat/area/';
const backendURL = '/api/references/area/';
const name = 'Райони населеного пункту';

const instance = {
  frontendURL,
  backendURL,
  name,
  useHierarchyPagination: true,
};
export default instance;
